import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {columnActionEvent, tableActionEvent} from '../../services/query_builder_events';
import {
    createPipelineStep,
    currentPipeline,
} from '../../utils/pipeline_utils';
import pipelineStepPropType from '../../utils/pipeline_step_proptype';
import {PipelineStepComponent} from './pipeline_steps/pipeline_step';

export default class PipelineBranch extends Component {
    state = {selectedStepId: null};

    constructor(props) {
        super(props);

        this.toggleOpenStep = this.toggleOpenStep.bind(this);
        this.updateStep = this.updateStep.bind(this);
        this.removeStep = this.removeStep.bind(this);
    }

    componentDidMount() {
        const {branch} = this.props;
        this.unbindColumnActionListener = columnActionEvent.listen((type, {parent, data = {}}) => {
            this.addStep(type, parent, data);
        });
        this.unbindTableActionListener = tableActionEvent.listen((type, {parent, data = {}}) => {
            this.addStep(type, parent, data);
        });
        this.toggleOpenStep(branch[0]);  // open the DatasetPanel
    }

    componentDidUpdate(__, prevState) {
        const {selectedStepId} = this.state;
        const {branch} = this.props;
        if (prevState.selectedStepId !== selectedStepId) {
            this.forceUpdate();
        } else if (selectedStepId) {
            const selectedStepIndex = branch.findIndex(({id}) => id === selectedStepId);
            if (selectedStepIndex === -1) {
                this.setState({selectedStepId: branch[branch.length - 1].id});
            }
        }
    }

    componentWillUnmount() {
        this.unbindColumnActionListener();
        this.unbindTableActionListener();
    }

    addStep(type, parent = this.props.branch[this.props.branch.length - 1], data = {}) {
        data = {...data};
        data.parents = [parent.id];
        const newStep = createPipelineStep(type, data, currentPipeline);
        this.props.addOrUpdateStep(newStep);
        this.toggleOpenStep(newStep);
    }

    toggleOpenStep(step) {
        this.setState({selectedStepId: step.id === this.state.selectedStepId ? null : step.id});
    }

    updateStep(step) {
        this.props.addOrUpdateStep(step);
    }

    removeStep(step) {
        this.props.removeStep(step);
    }

    render() {
        const {branch} = this.props;
        const {selectedStepId} = this.state;
        const selectedStepIndex = branch.findIndex(({id}) => id === selectedStepId);
        return (
            <>
                {branch.map((step, i) => (
                    <PipelineStepComponent
                        key={step.id}
                        step={step}
                        open={i === selectedStepIndex}
                        showTable={i === selectedStepIndex}
                        updateStep={this.updateStep}
                        toggleOpen={this.toggleOpenStep}
                        onRemove={this.removeStep}
                        adjacentToSelected={i + 1 === selectedStepIndex}
                    />
                ))}
            </>
        );
    }
}

PipelineBranch.propTypes = {
    branch: PropTypes.arrayOf(pipelineStepPropType).isRequired,
    addOrUpdateStep: PropTypes.func.isRequired,
    removeStep: PropTypes.func.isRequired,
};
